var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconBell = function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "21px",
    viewBox: "0 0 17 21"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uEA3A")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portal-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6,14.075 L16.7,16.175 L16.7,17.2 L0,17.2 L0,16.175 L2.1,14.075 L2.1,8.9 C2.1,7.2666585 2.50832925,5.85833925 3.325,4.675 C4.1583375,3.45832725 5.31665925,2.6666685 6.8,2.3 L6.8,1.575 C6.8,1.1416645 6.9499985,0.770834875 7.25,0.4625 C7.5500015,0.154165125 7.9166645,0 8.35,0 C8.7833355,0 9.15416513,0.154165125 9.4625,0.4625 C9.77083488,0.770834875 9.925,1.1416645 9.925,1.575 L9.925,2.3 C11.391674,2.6666685 12.5416625,3.4666605 13.375,4.7 C14.1916708,5.88333925 14.6,7.28332525 14.6,8.9 L14.6,14.075 Z M8.35,20.325 C7.76666375,20.325 7.27083538,20.125002 6.8625,19.725 C6.45416463,19.324998 6.25,18.8416695 6.25,18.275 L10.45,18.275 C10.45,18.8416695 10.2416688,19.324998 9.825,19.725 C9.40833125,20.125002 8.9166695,20.325 8.35,20.325 Z",
    id: "\\uEA3A",
    fill: "#959595",
    fillRule: "nonzero",
    transform: "translate(8.350000, 10.162500) scale(1, -1) rotate(-180.000000) translate(-8.350000, -10.162500) "
  }))));
};

export default __webpack_public_path__ + "static/media/icon-bell.63b9c571.svg";
export { SvgIconBell as ReactComponent };